export const NEW_DEAL_TODAY = 'New deal today';

export const SECONDARY_DEAL_COMPONENT = {
  goToDeal: 'Go to ##DEAL## deal',
  view: 'View',
};
export const FEATURED_DEAL_CARD_COMPONENT = {
  featuredDealTitle: 'Featured Deal!',
  goToDeal: 'Go to ##DEAL## deal',
  view: 'View',
};
export const MAIN_DEAL_COMPONENT = {
  bannerHideDetails: 'Hide deal detail -',
  claim: 'CLAIM',
  dealsToChoose: 'Experiences to Choose From',
  giftIt: 'Gift it!',
  highlights: 'Highlights',
  location: 'Location',
  productFeatures: 'Product Features',
  productSpecifications: 'Product Specifications',
  share: 'Share',
};
export const MAIN_DEAL_AVAILAVILITY_COMPONENT = {
  availability: 'Availability',
};
export const MAIN_DEAL_BOUGHT_COUNT_COMPONENT = {
  boughtText: 'bought',
  remainingText: 'remaining',
};
export const MAIN_DEAL_CYF_BANNER_COMPONENT = {
  cyfBannerAltText: 'Choose your flight times and airline with instant booking',
};
export const MAIN_DEAL_DISCOUNT_COMPONENT = {
  save: 'Save',
  saveUpTo: 'Save up to',
};
export const MAIN_DEAL_FINE_PRINT_COMPONENT = {
  adminFeeTerm: '*Admin fee based on checkout basket value applies',
  dealWillBeAdvertised: 'This deal will be advertised on site until',
  finePrintText: 'The Fine Print',
  payPalCreditRepresentativeText: `Representative Example:
  <ul style="padding-left:15px;"> 
  <li> Representative 23.9% APR (variable).</li>
  <li> Purchase rate 23.9% p.a. (variable).</li>
  <li> Assumed credit limit £1200.</li>
  </ul>`,
  payPalPayLaterFinePrintText:
    'Choose <a href="https://www.paypal.com/uk/webapps/mpp/paypal-payin3" target="_blank">Pay in 3 </a> at checkout and enjoy the power to split your purchase into three interest-free payments, with no set up fees or charges.* It’s a great way to help you stay in control of your budget.',
  preOrderBuyAndRedeem: (estimatedDelivery) =>
    `Buy & redeem this deal now and get delivery from ${estimatedDelivery}`,
  priceMayChange: 'Price is subject to change.',
};
export const MAIN_DEAL_FULL_DETAILS_COMPONENT = {
  descriptionForGoogle: '***Details for package options only***',
  fullDetails: 'Full Details',
};
export const MAIN_DEAL_META_BLOCK_COMPONENT = {
  authentic: 'The authenticity of this product has been verified by 5pm',
  timerDealsEndsSoonHeading: 'Deal Expiring Soon',
  //  fivepm: 'The authenticity of this product has been verified by 5pm','living-social': 'The authenticity of this product has been verified by Living Social',wowcher: 'The authenticity of this product has been verified by Wowcher',
  timerPriceDropHeading: 'Flash sale until',
};
export const MAIN_DEAL_NATIVE_SHARE_COMPONENT = {
  share: 'Share',
};
export const MAIN_DEAL_REDEEM_COMPONENT = {
  howToRedeem: 'How To Redeem',
};
export const MAIN_DEAL_REVIEW_OVERVIEW_COMPONENT = {
  reviewsIoAltText: 'Reviews IO logo',
};
export const MAIN_DEAL_REVIEWS_COMPONENT = {
  reviewsIoAltText: 'Reviews IO logo',
  tripAdvisorAltText: 'Trip Advisor logo',
};

export const MEDIUM_DEAL_COMPONENT = {
  goToDeal: 'Go to ##DEAL## deal',
  view: 'View',
};
export const MAIN_DEAL_REVIEW_ITEM_COMPONENT = {
  anonymousUser: 'Anonymous User',
};
export const SECOND_CHECKOUT_DEAL_COMPONENT = {
  buyNow: 'Buy now',
  from: 'From',
  now: 'Now',
  was: 'was',
};
export const SOLD_OUT_BANNER_COMPONENT = {
  bannerButtonText: 'notify me',
  bannerPlaceholder: 'Email Address',
  bannerShowLink: 'See Deal Detail +',
  bannerText: 'We will notify you when this product becomes available.',
  bannerTextDay: 'Check back tomorrow as more will be available.',
  bannerTextWeek: 'Check back next week as more will be available.',
  bannerTitle: 'Out of stock!',
  enterValidEmail: 'Please enter a valid email',
  requiredField: 'Required field',
  subscriptionFail: `Email wasn't registered`,
  subscriptionSuccessful: 'Email registered',
};

export const TWO_BY_TWO_DEAL_CARD_COMPONENT = {
  goToDeal: 'Go to ##DEAL## deal',
  sponsoredSearch: 'Sponsored',
  view: 'View',
};
export const MAIN_DEAL_WAS_COMPONENT = { wasText: 'was' };
export const XL_DEAL_CARD_COMPONENT = {
  goToDeal: 'Go to ##DEAL## deal',
  view: 'View',
};
export const AMENITIES_BUTTON_COMPONENT = {
  showMore: 'Show more',
};
export const AMENITIES_DETAILS_COMPONENT = {
  title: 'Amenities',
};
export const CONNECTED_BOTTOM_DEALS_COMPONENT = {
  END_OF_FEED: {
    endOfFeedMessage: 'All deals loaded!',
  },
  LOAD_PREVIOUS: {
    loadPreviousButtonText: 'Load Previous',
  },
};

export const GIFT_BOX_CAROUSEL_COMPONENT = {
  seeMoreButton: 'See More',
};
export const I_HEALTH_COMPONENT = {
  INVASIVE_HEALTH: {
    noHurry: {
      body: "Our health offers are here for longer so you've got time to make the right decision.",
      imageAltText: "There's no hurry",
      title: "There's no hurry",
    },

    notSure: {
      body: "If you change your mind after buying this deal or find you are medically unsuitable, we'll give you a refund.",
      imageAltText: 'Not sure?',
      title: 'Not sure?',
    },

    safeHands: {
      body: 'We only use qualified merchants to ensure you get the best possible care and service. Before redeeming your voucher with a merchant, take the time to do some research to ensure you are happy with them and the products and services that they offer.',
      imageAltText: "You're in safe hands",
      title: "You're in safe hands",
    },
    // need to change this for all brands
    timeToThink: {
      body: 'Time to think',
      imageAltText: 'Time to think',
      title:
        'Your voucher is valid for at least six months to give you enough time to consider wether you wish to proceed with the treatment.',
    },
    title: '5PM Wellbeing',
  },
};
export const CATEGORY_MAIN_DEAL_COMPONENT = {
  goToDeal: 'Go to ##DEAL## deal',
  view: 'View',
};
export const CHOOSE_YOUR_QUANTITY_COMPONENT = {
  chooseYourQuantity: 'choose your quantity on checkout',
};
export const EMPTY_SEARCH_DEAL_COMPONENT = {
  noFilterResult:
    'There were no results for your selected filters. Please broaden your search and try again.',
  noSearchResult:
    "There were no search results for <span class='search-results__term'>'##TEXT##'</span>. Here are today's top deals instead:",
};
export const DEAL_SOCIAL_CUES_BOTTOM_COMPONENT = {
  save: 'Save',
  saveUpTo: 'Save up to',
  socialCuesTotalBought: '##COUNT## Bought',
  socialCuesTotalRemaining: '##COUNT## Remaining',
};
export const DEAL_SOCIAL_CUES_INFO_COMPONENT = {
  limitedAvailability: 'Limited availability',
};
export const NORMAL_PRICE_SPLAT_COMPONENT = {
  upTo: 'up to',
};
export const POSTAGE_AND_PACKAGING_TEXT_COMPONENT = {
  postageAndPackagingShortForm: 'P&P',
};
export const VAT_TEXT_COMPONENT = {
  vatNumber: 'VAT number: ',
  vatText: 'This deal is brought to you by ',
};
export const BOOKING_ALTERNATIVE_FLIGHTS = {
  alternativeFlightsChoose: 'Choose An Alternative Flight',
  alternativeFlightsTitle: 'ALTERNATIVE FLIGHTS',
  inboundRangeTime: 'Inbound Departure Time',
  noAlternativeFlights: 'Sorry there are no alternative flights available.',
  noFlightsForSelection: 'Sorry, there are no flights for the times selected.',
  outboundRangeTime: 'Outbound Departure Time',
};
export const BOOKING_CALENDAR = {
  bookableAtRedemption: 'Choose your dates for travel on redemption',
  bookingNoResults: 'Sorry, there are no results for these selections.',
  pricesShownLowest: 'prices shown refer to the lowest priced product',
};
export const BOOKING_CALENDAR_AIRPORTS = {
  cyfBookingStepTwo: 'Step 2: Your Departure Airport',
};
export const BOOKING_CALENDAR_CELL = {
  dateAvailable: 'Available',
  soldOut: 'SOLD OUT',
};
export const BOOKING_CALENDAR_CELL_BEGIN_END = {
  soldOut: 'SOLD OUT',
};
export const BOOKING_CALENDAR_CELLS = {
  bookableAtRedemption: 'Choose your dates for travel on redemption',
};
export const BOOKING_CALENDAR_CELLS_BEGIN_END = {
  addDates: 'Select Date',
  checkIn: 'Check In',
  checkOut: 'Check Out',
  clearButton: 'Clear',
};
export const BOOKING_CALENDAR_CLEAR = {
  clearSelection: 'Clear Selection',
};
export const BOOKING_CALENDAR_NIGHTS = {
  cyfBookingStepThree: 'Step 3: Number of Nights',
};
export const BOOKING_CALENDAR_PACKAGE = {
  checkIn: 'Check In',
  checkOut: 'Check Out',
  date: 'Date',
  nights: 'Nights',
  now: 'Now',
  saveUpTo: 'Save up to',
  soldOut: 'SOLD OUT',
};
export const BOOKING_CALENDAR_PACKAGES = {
  bcorStepOne: 'Choose number of nights',
};
export const BOOKING_CALENDAR_PASSENGERS = {
  cyfBookingStepOne: 'Step 1: Number of Passengers',
};
export const BOOKING_CALENDAR_PAYMENTS = {
  depositPayDeposit: 'Pay Deposit:',
  depositPayFull: 'Pay Full Amount:',
};
export const BOOKING_CALENDAR_PRODUCT = {
  checkIn: 'Check In',
  checkOut: 'Check Out',
  date: 'Date',
  now: 'Now',
  save: 'Save',
  was: 'was',
};
export const CALENDAR = {
  BUY_EXCL: 'BUY!',
  GIVE_AS_A_GIFT: 'Give as a gift',
  PROCEED: 'Proceed',
  RESERVE_CHECKOUT: 'RESERVE & CHECKOUT',
};
export const CALENDAR_CONTAINER = {
  bcorGiftMessage:
    'Date Flexibility: Gift recipients choose their dates when redeeming their voucher.',
  bookingStepOne: 'Step 1: Choose a date',
  bookingStepThree: 'Step 3: Choose payment option',
  bookingStepTwo: 'Step 2: Choose your stay',
  chooseArrival: 'Please choose your arrival date',
  cmChooseCheckoutDates: 'Please select your check-out date.',
  cmChooseDates: 'Please select your check-in and check-out dates.',
  cmGiftStepOne: 'Choose number of nights',
  cmStepOne: 'Choose Check-In and Check-Out Dates',
  cmStepThree: 'Choose payment option',
  cmStepTwo: 'Choose your stay',
  cyfBookingStepFive: 'Step 5: Choose your Stay',
  cyfBookingStepFour: 'Step 4: Choose Arrival Date',
  cyfBookingStepOne: 'Step 1: Number of Passengers',
  cyfBookingStepSix: 'Step 6: Included Flight',
  cyfBookingStepSixA: 'Step 6: Your Chosen Flight',
  cyfBookingStepThree: 'Step 3: Number of Nights',
  cyfBookingStepTwo: 'Step 2: Your Departure Airport',
  depositAvailable: (price) =>
    `Deposit payment FROM ${price}. Balance to be paid directly to the merchant`,
  flightErrorDetails: `Sorry, there's been a problem getting the flights.`,
  giveAsAGift: 'Give as a gift',
  noProducts:
    'Sorry, no products available for selected dates. Please try other dates.',
  noProductsForNights:
    'Sorry, no products are available for your chosen nights. Please try a different selection.',
  useOriginalFlight: 'use original',
};
export const CALENDAR_ON_REDEMPTION_CONTAINER = {
  bcorGiftMessage:
    'Date Flexibility: Gift recipients choose their dates when redeeming their voucher.',
  bcorStepOne: 'Choose number of nights',
  bcorStepOneSingleNight: 'Number of nights',
  bcorStepTwo: 'Choose your option',
};
export const CALENDAR_ON_REDEMPTION_NIGHTS = {
  bcorStepOne: 'Choose number of nights',
  bcorStepOneSingleNight: 'Number of nights',
};
export const CALENDAR_ON_REDEMPTION_PRODUCT = {
  now: 'Now',
  save: 'Save',
  was: 'was',
};
export const CALENDAR_SOCIAL_CUE = {
  authentic: 'The authenticity of this product has been verified by 5pm',
};
export const CHANNEL_MANAGER_NIGHTS = {
  cmChooseNights: 'Choose number of nights',
};
export const FLIGHT_PAIR = {
  selectFlight: 'select flight',
};
export const CHOOSE_YOUR_OPTIONS_DROPDOWN_COMPONENT = {
  bestseller: 'BEST SELLING OPTION*',
  bestsellerExplain: '*This is the best selling option within this deal.',
  cueVipExclusive: 'VIP EXCLUSIVE!',
  depositMessage:
    'Deposit payment <b>FROM %price</b>. Balance to be paid directly to merchant.',
  payDeposit: 'Pay Deposit:',
  payFullDeposit: 'Pay Full Amount:',
  pleaseChoose: 'Please choose',
  pleaseChooseAnotherOption: 'Please choose another option',
  pleaseChooseOneOption: 'Please choose one of the options',
  soldOut: 'SOLD OUT',
};
export const DEAL_BUY_BUTTON_COMPONENT = {
  buyButton: 'BUY!',
  buyNowButton: 'BUY NOW!',
  buyNowButtonNoExclamation: 'Buy now',
  giveAsAGiftButton: 'Give as a gift',
};
export const DEAL_CHOOSE_YOUR_OPTIONS_BUTTON_COMPONENT = {
  buyNowButtonNoExclamation: 'Buy now',
  chooseYourOptions: 'Choose your options',
  giveAsAGiftButton: 'Give as a gift',
};
export const DEAL_CHOOSE_YOUR_OPTIONS_CLAIM_MESSAGE_COMPONENT = {
  giftPackUpgrade: (extra) =>
    `Upgrade: Additional ${extra} required at checkout`,
};
export const DEAL_CHOOSE_YOUR_OPTIONS_ITEM_COMPONENT = {
  basedOnSharing: 'This deal is based on 2 people sharing',
  bestseller: 'BEST SELLING OPTION*',
  percentageOff: '% off',
  quantity: 'Quantity',
  save: 'Save',
  selectQuantity: 'Select Quantity',
  soldOut: 'SOLD OUT',
};
export const DEAL_CHOOSE_YOUR_OPTIONS_MODAL = {
  bestseller: 'BEST SELLING OPTION*',
  bestsellerExplain: '*This is the best selling option within this deal.',
  chooseYourOptions: 'Choose your options',
  cueVipExclusive: 'VIP EXCLUSIVE!',
  depositMessage:
    'Deposit payment <b>FROM %price</b>. Balance to be paid directly to merchant.',
  giveAsAGiftButton: 'Give as a gift',
  payDeposit: 'Pay Deposit:',
  payFullDeposit: 'Pay Full Amount:',
  pleaseChoose: 'Please choose',
  pleaseChooseOneOption: 'Please choose one of the options',
  proceed: 'Proceed',
  productFeatures: 'Product Features',
  reserveCheckout: 'RESERVE & CHECKOUT',
};
export const DEAL_CHOOSE_YOUR_OPTIONS_MULTI_COMPONENT = {
  bestsellerExplain: '*This is the best selling option within this deal.',
  buyButtonText: 'BUY!',
  chooseYourOptions: 'Choose your options',
  dealDailyCapReached:
    'The maximum quantity of this deal that you can buy today is ###dealcap###',
  dealLimitReached:
    'You already have the maximum quantity of this deal in your basket. Please proceed to the checkout or edit your basket.',
  giveAsAGiftButton: 'Give as a gift',
  selectOptionWarning: 'Please choose at least one product',
};
export const DEAL_CHOOSE_YOUR_PRODUCT_BUTTON_COMPONENT = {
  buyNowButtonNoExclamation: 'Buy now',
  chooseYourOptions: 'Choose your options',
};
export const DEAL_EXPRESS_BUY_BUTTON_COMPONENT = {
  claim: 'CLAIM',
  quickBuy: 'Quick Buy',
};
export const DEAL_GIFT_BUTTON = {
  giveAsAGiftButton: 'Give as a gift',
};
export const DEAL_LEAD_GEN_COMPONENT = {
  callToBook: 'Call to book',
};
export const DEAL_SINGLE_SELECT_MODAL = {
  buyNowButtonNoExclamation: 'Buy now',
  chooseYourOptions: 'Choose your options',
  location: 'Location',
  now: 'Now',
  payDeposit: 'Pay Deposit:',
  payFullDeposit: 'Pay Full Amount:',
  productFeatures: 'Product Features',
  wasText: 'was',
};
export const DEAL_VIEW_AVAILABILITY_BUTTON = {
  buyExclamation: 'BUY!',
  giftIt: 'Gift it!',
  giveAsAGiftButton: 'Give as a gift',
  viewAvailability: 'View Availability',
};
export const MAIN_DEAL_COMBINED_BUTTON_COMPONENT = {
  buyExclamation: 'BUY!',
  buyNowButton: 'BUY NOW!',
  chooseYourOptions: 'Choose your options',
  claim: 'CLAIM',
};
export const MAIN_DEAL_COMBINED_GIFT_BUTTON_COMPONENT = {
  giftIt: 'Gift it!',
  giveAsAGiftButton: 'Give as a gift',
};
export const RESERVE_BUTTON_COMPONENT = {
  depositsButton: 'Deposits ',
  reserveNowButton: 'RESERVE NOW ',
};
export const SECOND_CHECKOUT_CHOOSE_YOUR_OPTIONS_MODAL = {
  bestseller: 'BEST SELLING OPTION*',
  buyNow: 'Buy now',
  chooseYourOptions: 'Choose your options',
  depositMessage:
    'Deposit payment <b>FROM %price</b>. Balance to be paid directly to merchant.',
  from: 'From',
  giveAsAGiftButton: 'Give as a gift',
  location: 'Location',
  now: 'Now',
  payDeposit: 'Pay Deposit:',
  payFullDeposit: 'Pay Full Amount:',
  pleaseChoose: 'Please choose',
  pleaseChooseOneOption: 'Please choose one of the options',
  productFeatures: 'Product Features',
  wasText: 'was',
};
export const SECOND_CHECKOUT_CHOOSE_YOUR_PRODUCT_MODAL = {
  bestseller: 'BEST SELLING OPTION*',
  buyNow: 'Buy now',
  chooseYourOptions: 'Choose your options',
  depositMessage:
    'Deposit payment <b>FROM %price</b>. Balance to be paid directly to merchant.',
  from: 'From',
  giveAsAGiftButton: 'Give as a gift',
  location: 'Location',
  now: 'Now',
  pleaseChoose: 'Please choose',
  pleaseChooseOneOption: 'Please choose one of the options',
  productFeatures: 'Product Features',
  wasText: 'was',
};
export const GIFTING_MODAL_COMPONENT = {
  // GIFTING_AT_WOWCHER = {
  //   fivepm: 'GIFTING EXPLAINED',
  //   'living-social': 'gifting explained',
  //   wowcher: 'GIFTING EXPLAINED',
  // };
  giftingExplainedText: 'GIFTING EXPLAINED',
  giveAsAGiftButton: 'Give as a gift',
};
export const PLAY_BUTTON_COMPONENT = {
  pauseVideo: 'Pause video',
  playVideo: 'Play video',
};
export const GIFTING_BUTTON = {
  gifting: 'GIFTING?',
};
export const GIFTING_EXPLAINED = {
  discounts: 'PRICES AND DISCOUNTS ARE HIDDEN',
  pdf: 'PDF AVAILABLE FOR SAME DAY GIFTING',
};
export const GIFTING_MODAL = {
  giftingAtBrand: 'GIFTING EXPLAINED',
  giveAsAGift: 'Give as a gift',
};
